import { render, staticRenderFns } from "./customForm.vue?vue&type=template&id=d8c34f3e&scoped=true"
import script from "./customForm.vue?vue&type=script&lang=js"
export * from "./customForm.vue?vue&type=script&lang=js"
import style0 from "./customForm.vue?vue&type=style&index=0&id=d8c34f3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c34f3e",
  null
  
)

export default component.exports